export enum ERFxTypeEnum {
  BLD = 'BLD',
  RFQ = 'RFQ',
  RFI = 'RFI',
  RFP = 'RFP',
}

export const CUST_CARE_PHONE = '02-034-4333 #2';
